function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChartIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 315.766 317.769",
    style: {
      enableBackground: "new 0 0 315.766 317.769"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bd88ec"
    },
    d: "M240.163 204.446h54.459v100.446h-54.459V204.446z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7944b2"
    },
    d: "M267.392 204.446h27.229v100.446h-27.229V204.446z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bd88ec"
    },
    d: "M194.781 204.446h-27.229v100.446h54.458V204.446h-27.229z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8d58c6"
    },
    d: "M194.781 204.446h27.229v100.446h-27.229V204.446z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bd88ec"
    },
    d: "M122.169 230.603 94.94 244.218v60.674h54.458v-87.904l-27.229 13.615z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7944b2"
    },
    d: "m149.399 216.988-27.229 13.615v74.289h27.229v-87.904z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5c484f"
    },
    d: "M40.481 77.376h18.153v27.229H40.481V77.376zm0 81.688h18.153v27.229H40.481v-27.229z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3d3139"
    },
    d: "M49.558 77.376h9.076v27.229h-9.076V77.376zm0 81.688h9.076v27.229h-9.076v-27.229z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bd88ec"
    },
    d: "M22.328 240.752h54.459v64.14H22.328v-64.14z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8d58c6"
    },
    d: "M49.558 240.752h27.229v64.14H49.558v-64.14z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bd88ec"
    },
    d: "m267.073 122.297-7.304 16.61 14.712 6.466-45.54 22.767h-74.756l-70.466 36.306H13.252v18.153h74.757l70.466-36.306h74.757l49.363-24.678-3.653 15.637 17.674 4.13 9.777-41.81-39.32-17.275z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8d58c6"
    },
    d: "m282.595 161.616-3.653 15.637 17.674 4.13 9.777-41.81-39.319-17.275-7.304 16.61 14.712 6.466-45.54 22.767h-70.466v18.153h74.757l49.362-24.678z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bd88ec"
    },
    d: "M22.328 95.529v72.612h54.459V95.529H22.328z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8d58c6"
    },
    d: "M49.558 95.529h27.229v72.612H49.558V95.529z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5c484f"
    },
    d: "M113.093 41.07h18.153v27.229h-18.153V41.07zm0 81.688h18.153v27.229h-18.153v-27.229z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3d3139"
    },
    d: "M122.169 41.07h9.076v27.229h-9.076V41.07zm0 81.688h9.076v27.229h-9.076v-27.229z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bd88ec"
    },
    d: "M94.94 59.223v72.612h54.459V59.223H94.94z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7944b2"
    },
    d: "M122.169 59.223h27.229v72.612h-27.229V59.223z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5c484f"
    },
    d: "M258.316 4.159h18.153v27.229h-18.153V4.159zm0 82.293h18.153v27.229h-18.153V86.452z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3d3139"
    },
    d: "M267.392 4.159h9.076v27.229h-9.076V4.159zm0 82.293h9.076v27.229h-9.076V86.452z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bd88ec"
    },
    d: "M240.163 22.312v73.217h54.459V22.312h-54.459z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7944b2"
    },
    d: "M267.392 22.312h27.229v73.217h-27.229V22.312z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5c484f"
    },
    d: "M185.704 22.917h18.153v27.229h-18.153V22.917zm0 81.688h18.153v27.229h-18.153v-27.229z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3d3139"
    },
    d: "M194.781 22.917h9.076v27.229h-9.076V22.917zm0 81.688h9.076v27.229h-9.076v-27.229z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bd88ec"
    },
    d: "M167.551 41.07v72.612h54.459V41.07h-54.459z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8d58c6"
    },
    d: "M194.781 41.07h27.229v72.612h-27.229V41.07z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChartIcon);
export default __webpack_public_path__ + "static/media/chartIcon.221e6b23c33f68398d67c59e7a94449c.svg";
export { ForwardRef as ReactComponent };